import type { TTextLeaf } from './Text.types';

export const getTextColor = (text: TTextLeaf) => {
  const { marks } = text;

  //find the first mark that has a color attribute
  const color = marks?.find((mark) => mark.type === 'textStyle')?.attrs?.color;

  return color;
};

const LINK_MARK_TYPES = ['link', 'timestampLink'];

export const renderableMarks = <TMark extends { type: string }>(
  leaf: {
    text: string;
    animation?: unknown;
    marks?: TMark[];
  },
  isInsideLink = false,
) => {
  const isWhitespaceOnly = !leaf.animation && !leaf.text?.trim();
  const marks = leaf.marks || [];
  return isWhitespaceOnly || isInsideLink ? marks.filter((mark) => !LINK_MARK_TYPES.includes(mark.type)) : marks;
};
